<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
  <div id="component-chat-log" class="m-8" v-if="chatData">
    <a href="/dashboard/analytics">
      <FeatherIcon
        icon="HomeIcon"
        style="width: 30px; vertica-align: bottom"
      ></FeatherIcon>
      <span style="vertical-align: super; font-weight: 900">Back Home</span></a
    >
    <div
      v-for="(msg, index) in chatData"
      class="msg-grp-container"
      :key="index"
    >
      <!-- If previouse msg is older than current time -->
      <template v-if="chatData[index - 1] && !msg.HideFromUI">
        <vs-divider v-if="!isSameDay(msg.time, chatData[index - 1].time)">
          <span>{{ toDate(msg.time) }}</span>
        </vs-divider>
        <div
          class="spacer mt-8"
          v-if="!hasSentPreviousMsg(chatData[index - 1].isSent, msg.isSent)"
        ></div>
      </template>

      <div
        class="flex items-start"
        :class="[{ 'flex-row-reverse': msg.isSent }]"
      >
        <template v-if="chatData[index - 1] && !msg.HideFromUI">
          <template
            v-if="
              !hasSentPreviousMsg(chatData[index - 1].isSent, msg.isSent) ||
              !isSameDay(msg.time, chatData[index - 1].time)
            "
          >
            <vs-avatar
              size="40px"
              class="m-0 flex-shrink-0"
              style="background: white"
              :class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
              :src="senderImg(msg.isSent)"
            ></vs-avatar>
          </template>
        </template>

        <template v-if="index == 0 && !msg.HideFromUI">
          <vs-avatar
            size="40px"
            class="m-0 flex-shrink-0"
            :class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
            :src="senderImg(msg.isSent)"
          ></vs-avatar>
        </template>

        <template v-if="chatData[index - 1] && !msg.HideFromUI">
          <div
            class="mr-16"
            v-if="
              !(
                !hasSentPreviousMsg(chatData[index - 1].isSent, msg.isSent) ||
                !isSameDay(msg.time, chatData[index - 1].time)
              )
            "
          ></div>
        </template>

        <div
          v-if="!msg.HideFromUI"
          class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg"
          :class="{
            'bg-primary-gradient text-white max-w-sm': msg.isSent,
            'border border-solid border-grey-light bg-white': !msg.isSent,
          }"
        >
          <div
            v-if="!msg.HideFromUI && getComponentsFromHtml(msg.content) == null"
            class="chat-cart-html"
            v-html="msg.content"
          ></div>
          <div v-else>
            <component
              v-if="!msg.HideFromUI && !msg.SkipCards"
              :is="getComponentsFromHtml(msg.content)"
              :RawSettings="msg.content"
              @RaiseCta="RaiseCta"
            ></component>
          </div>
        </div>
      </div>
    </div>
    <template v-if="OtherIsTyping">
      <div class="flex items-start">
        <vs-avatar
          size="40px"
          class="m-0 flex-shrink-0"
          :class="'sm:mr-5 mr-3'"
          :src="senderImg(false)"
          style="background: white"
        ></vs-avatar>
        <div
          class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg border border-solid border-grey-light bg-white"
        >
          Waiting for AI ...
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import TCVCard from "@/views/components/chat/TCVCard.vue";
import FeatherIcon from "@/components/FeatherIcon.vue";
import TCVelikClient from "@/TCVelikClient/TCVelikClient.js";

export default {
  props: {
    userId: {
      type: Number,
      required: true,
    },
    ChatMessages: {
      type: Array,
      required: true,
    },
    OtherIsTyping: {
      type: Boolean,
      required: false,
    },
    CurrentUser: {
      type: Object,
      required: true,
    },
    // New props for search functionality
    searchQuery: {
      type: String,
      required: false,
      default: "",
    },
    searchIntents: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    enableSearch: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      customComponent: "",
      contactsArr: [
        {
          id: 1,
          name: "Pavel Donchev",
          about: "Making easy things hard since 1986.",
          img: "avatar-s-1.png",
          status: "offline",
        },
        {
          id: 2,
          name: "TCVeli Assistant",
          about: "Making easy things hard since 1986.",
          img: "/img/logo.375133a0.png",
          status: "offline",
        },
      ],
    };
  },
  computed: {
    chatData() {
      return this.ChatMessages;
    },
    contactIndex() {
      return this.contactsArr.findIndex((contact) => contact.id == this.userId);
    },
    userImg() {
      if (this.contactIndex !== -1)
        return this.contactsArr[this.contactIndex].img;
    },
    activeUserImg() {
      return this.$store.state.AppActiveUser.img;
    },
    senderImg() {
      return (isSentByActiveUser) => {
        if (isSentByActiveUser) return this.CurrentUser.img;
        else {
          return require("@/assets/images/logo/logo.jpg");
        }
      };
    },
    hasSentPreviousMsg() {
      return (last_sender, current_sender) => last_sender == current_sender;
    },
  },
  methods: {
    isSameDay(time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to));
      const date_time_from = new Date(Date.parse(time_from));
      return (
        date_time_to.getFullYear() === date_time_from.getFullYear() &&
        date_time_to.getMonth() === date_time_from.getMonth() &&
        date_time_to.getDate() === date_time_from.getDate()
      );
    },
    toDate(time) {
      const locale = "en-us";
      const date_obj = new Date(Date.parse(time));
      const monthName = date_obj.toLocaleString(locale, {
        month: "short",
      });
      return date_obj.getDate() + " " + monthName;
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight;
      });
    },
    getComponentsFromHtml(html) {
      if (html.toLowerCase().indexOf("tcvcard") == -1) return null;
      return TCVCard;
    },
    RaiseCta(cta, data) {
      // this.$parent.$emit("RaiseCta", cta, data);
      // this.$parent.$parent.$emit("RaiseCta", cta, data); // A bit hacky since we're in a chat log that is in a chat, that is in a popup. TO FIX BETTER LATER!!!
      // this.$emit("RaiseCta", cta, data);
      this.$emit("RaiseCta", cta, data);
    },

    // Search functionality methods
    async performSearch(query, intents = {}) {
      if (!this.enableSearch) {
        console.warn("Search functionality is not enabled for this component");
        return null;
      }

      try {
        const searchRequest = {
          query: query || this.searchQuery,
          urlContext: "",
          shortResults: true,
          format: "",
          maxCount: 50,
          intentParams: intents || this.searchIntents
        };

        console.log("Performing search with request:", searchRequest);

        const response = await TCVelikClient.PostRelative("/api/SearchWithIntent", searchRequest);
        
        if (response && response.data) {
          console.log("Search results:", response.data);
          return response.data;
        }
        
        return null;
      } catch (error) {
        console.error("Search error:", error);
        this.$emit("searchError", error);
        return null;
      }
    },

    async getAvailableIntents() {
      try {
        const response = await TCVelikClient.GetRelative("/api/existingintents");
        if (response && response.data) {
          console.log("Available intents:", response.data);
          return response.data;
        }
        return {};
      } catch (error) {
        console.error("Error fetching available intents:", error);
        return {};
      }
    },

    async searchWithIntents(query, intentParams) {
      return await this.performSearch(query, intentParams);
    },

    // Method to trigger search from parent component
    async triggerSearch(query, intents) {
      const results = await this.performSearch(query, intents);
      this.$emit("searchResults", results);
      return results;
    },
  },
  updated() {
    this.scrollToBottom();
  },
  mounted() {
    this.scrollToBottom();
  },
  components: {
    TCVCard,
    FeatherIcon,
  },
};
</script>
<style>
.chat-cart-html, .chat-cart-html p {
  margin-bottom: 10px !important;
  font-size:1.2rem;
}
.chat-cart-html ul,
.chat-cart-html ol {
  padding: 10px;
  list-style: disc;
}
.chat-cart-html li {
  margin-bottom: 5px;
}
.chat-cart-html h1, .chat-cart-html h2, .chat-cart-html h3, .chat-cart-html h4, .chat-cart-html h5, .chat-cart-html h6 {
  margin: 20px 0px;
  font-weight: 900;
}
</style>
